import classNames from 'classnames';
import React from 'react';

import { Space } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';

import { ICommentItem } from '../../../interfaces/reviews';
import { useIsUserLogged, useUser } from '../../../store/hooks/users';
import { AuthorInfo } from '../../AuthorInfo';
import styles from '../comments-list.module.scss';

import { CardBody } from './CardBody';
import { ICommentProps } from './Comment';
import { Form } from './Form';

export interface ICommentCardProps
  extends Pick<
    ICommentProps,
    'handleCreateComment' | 'handleUpdateComment' | 'logo' | 'isRepresentative' | 'isModerator'
  > {
  item: ICommentItem;
  commentId: number;
  isBankAnswer?: boolean;
  handleOpenComments?: () => void;
}

export const Card: React.FC<ICommentCardProps> = ({
  item,
  commentId,
  isBankAnswer,
  handleCreateComment,
  handleOpenComments,
  handleUpdateComment,
  isRepresentative,
  isModerator,
}) => {
  const currentUser = useUser();
  const isLoggedIn = useIsUserLogged();

  const currentUserId = currentUser?.sub;

  const [showCommentFrom, setShowCommentForm] = useBoolean(false);
  const [editText, setEditText] = useBoolean(false);

  const handleShowCommentForm = () => setShowCommentForm.on();

  const handleEditClick = () => setEditText.on();

  const handleEditFormSubmit = async (text: string) => {
    await handleUpdateComment(text, item?.id, commentId);
    setEditText.off();
  };

  const handleCommentFormSubmit = async (text: string) => {
    await handleCreateComment(text, commentId);
    setShowCommentForm.off();
    handleOpenComments();
  };

  if (!item) return null;

  return (
    <>
      <Space align={'start'} justify={'space-between'} className={classNames(styles.commentInfo, 'h-mb-20')}>
        <AuthorInfo entity={item} isBankAnswer={isBankAnswer || item.authorRole === 'company'} />
      </Space>
      {editText ? (
        <Space>
          <Form
            forEdit
            label={`Редактировать комментарий`}
            onCancel={() => setEditText.off()}
            onSubmit={handleEditFormSubmit}
            initialState={item.text}
            currentUserId={currentUserId}
            showWysiwyg={isRepresentative || isModerator}
          />
        </Space>
      ) : (
        <CardBody
          item={item}
          isLoggedIn={isLoggedIn}
          isBankAnswer={isBankAnswer}
          handleShowCommentForm={handleShowCommentForm}
          handleEditClick={handleEditClick}
        />
      )}
      {showCommentFrom && !isBankAnswer && (
        <Form
          label={`Напишите комментарий`}
          onCancel={() => setShowCommentForm.off()}
          initialState={`${item.authorName}, `}
          onSubmit={handleCommentFormSubmit}
          currentUserId={currentUserId}
          showWysiwyg={isRepresentative || isModerator}
        />
      )}
    </>
  );
};
